import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from "vue";
import { INewRouteApplication } from "@/domain/entities/bbs/newRouteApplication.types";
import dayjs from "dayjs";
import NewRouteStatusChip from "@/components/shared/chip/NewRouteStatusChip.vue";


const __default__ = {
  name: "NewRouteApplicationRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  application: {
    type: Object as PropType<INewRouteApplication>,
    // required: true,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const usePeriodDisplayText = computed(() => {
  const useBeginDate = props.application?.useBeginDtm
    ? dayjs(props.application?.useBeginDtm).format("YYYY-MM-DD")
    : "";
  const useEndDate = props.application?.useEndDtm
    ? dayjs(props.application?.useEndDtm).format("YYYY-MM-DD")
    : "";
  return `${useBeginDate}~${useEndDate}`;
});

const lineTypeDisplayText = computed(
  () =>
    `[${props.application?.campusName ?? "-"}/${
      props.application?.workTimeName ?? "-"
    }]`
);

const __returned__ = { props, usePeriodDisplayText, lineTypeDisplayText, NewRouteStatusChip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})